import { get } from '../utils';

import { createSelector } from 'reselect';

export const baseSelector = (state) => get(state, 'entities', {});

export const eligibleAccountTypesSelector = createSelector(baseSelector, (entities) => {
	return get(entities, 'eligibleAccountTypes', {});
});

export const accountsSelector = createSelector(baseSelector, (state) =>
	get(state, 'account_by_type', {})
);

export const referralDataSelector = createSelector(baseSelector, (entities) =>
	get(entities, 'referral_data', {})
);

export const manageExternalAccountSelector = createSelector(baseSelector, (state) =>
	get(state, 'manage_external_account', {})
);

export const eligiblePlatformTiersSelector = createSelector(baseSelector, (state) => {
	const { platform_tiers } = get(state, 'eligible_platform_tiers', {});
	return {
		platform_tiers: platform_tiers || [],
	};
});

export const dynamicPlatformTiersSelector = createSelector(baseSelector, (state) => {
	const planList = get(state, 'dynamic_platform_tiers', {});
	return planList || [];
});

export const tierFootnotesSelector = createSelector(baseSelector, (state) => {
	const footnotes = get(state, 'eligible_platform_tiers.footnotes', {});
	return {
		debitAccountAccess: footnotes['debit_account_access'],
		stockBack: footnotes['stock_back'],
		metalCards: footnotes['metal_cards'],
		termsLink: footnotes['terms_and_condition_link'],
		customerService: footnotes['customer_service'],
	};
});

export const getCardDetailSelector = createSelector(baseSelector, (state) => {
	const cards = get(state, 'cards', {});
	return cards.selectedCard;
});
